import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Es en papel o digital?',
  a: 'Es un producto 100% digital. Recibís todos los módulos de forma inmediata en tu correo electrónico, con el manual principal, los 5 bonos y todo el material listo para usar e imprimir en casa o en cualquier centro de copiado las veces que necesites.'
}, {
  q: '¿Necesito experiencia previa para usarlo?',
  a: 'No. El sistema incluye el Capítulo 1 dedicado exclusivamente a explicarte cómo usar todo sin improvisar. En menos de una hora ya vas a saber exactamente qué usar, cuándo y cómo adaptarlo a cada cliente.'
}, {
  q: '¿Sirve para profesionales de cualquier provincia de Argentina?',
  a: 'Sí. Todo el contenido está basado en la normativa nacional vigente (Ley 19.587, Decreto 351 y resoluciones SRT) aplicable en todo el territorio argentino.'
}, {
  q: '¿Qué pasa si ya tengo algunas capacitaciones armadas?',
  a: 'El sistema se complementa con lo que ya tenés. No reemplaza tu trabajo: lo organiza, lo completa y lo eleva de nivel. Podés incorporar tus materiales al sistema y tener todo en un solo lugar.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'De forma inmediata. Apenas confirmada la compra, recibís el acceso completo en tu correo electrónico. En menos de 5 minutos ya podés estar revisando el sistema.'
}, {
  q: '¿Sirve si recién me recibí o si tengo pocos clientes?',
  a: 'Es el momento ideal para empezar con el pie derecho. Este sistema te da desde el primer día la estructura, el material y el respaldo legal que le lleva años construir a otros profesionales.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-20 bg-transparent" data-id="element-33">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-34">
        <div className="text-center mb-10 md:mb-12" data-id="element-35">
          <span className="inline-block px-6 py-2.5 mb-5 rounded-full border border-white/40 bg-[#566049] text-white font-semibold tracking-[0.18em] uppercase text-xs" data-id="element-36">
            Preguntas Frecuentes
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#2f3a2c] leading-tight" data-id="element-37">
            Respondemos a{' '}
            <em className="text-[#c06a52] not-italic font-bold italic" data-id="element-38">
              tus preguntas
            </em>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-2xl shadow-sm shadow-black/5" data-id="element-40">
                <button className="w-full px-6 md:px-8 py-5 md:py-6 text-left flex justify-between items-center gap-4 focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-41">
                  <span className="font-heading font-bold text-[#2f3a2c] text-lg md:text-xl" data-id="element-42">
                    {faq.q}
                  </span>
                  <span className="flex-shrink-0 w-9 h-9 rounded-full bg-[#566049] text-white flex items-center justify-center transition-colors" aria-hidden="true" data-id="element-43">
                    {isOpen ? <Minus className="w-4 h-4" data-id="element-44" /> : <Plus className="w-4 h-4" data-id="element-45" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-46">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-47">
                      <div className="px-6 md:px-8 pb-6 md:pb-7 -mt-1 text-slate-600 leading-relaxed text-[15px] md:text-base max-w-[58ch]" data-id="element-48">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}